import React from 'react';
import { useBranch } from 'contexts/BranchContext';


// 스타일 객체를 return 문 밖에 정의합니다.
// Home.js의 전반적인 어두운 테마와 어울리도록 스타일을 적용했습니다.
const styles = {
    footerContainer: {
        width: '100%',
        boxSizing: 'border-box',
        paddingBottom: 'calc(60px + env(safe-area-inset-bottom, 40px))',
        marginTop: '20px',
    },
    footerContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px', // 각 줄 사이의 간격
    },
    footerText: {
        fontFamily: "'Pretendard', sans-serif", // 폰트 이름에 따옴표 추가
        fontSize: '12px',
        fontWeight: 400,
        color: '#A9A9A9', // 어두운 배경에서 잘 보이는 밝은 회색
        lineHeight: 1.6,
        margin: 0, // p 태그의 기본 마진 제거
    },
    // <p> 태그 안의 <strong> 태그에 개별 적용할 스타일
    footerTextStrong: {
        fontWeight: 600,
        color: '#E0E0E0', // 레이블은 조금 더 밝은 색상
    },
    footerDivider: {
        margin: '0 4px',
    },
    horizonBar: {
        width: '100%',
        height: '1px',
        background: '#3A394A',
        marginBottom: '15px',
    },
};


function Footer() {
    const { currentBranch } = useBranch();
    const footerInfo = currentBranch?.footerInfo || {
        companyName: '',
        ceoName: '',
        businessNumber: '',
        ecommerceNumber: '',
        address: '',
        csPhone: '',
        email: ''
    };

    return (
        <footer style={styles.footerContainer}>
            <div className="horizonBar" style={styles.horizonBar} />
            <div style={styles.footerContent}>
                <p style={styles.footerText}>
                    <strong style={styles.footerTextStrong}>상호명</strong> : {footerInfo.companyName}
                    {/* <span style={styles.footerDivider}> | </span>
                    <strong style={styles.footerTextStrong}>대표자명</strong> : {footerInfo.ceoName} */}
                </p>
                <p style={styles.footerText}>
                    <strong style={styles.footerTextStrong}>사업자등록번호</strong> : {footerInfo.businessNumber}
                </p>
                <p style={styles.footerText}>
                    <strong style={styles.footerTextStrong}>통신판매업신고번호</strong> : {footerInfo.ecommerceNumber}
                </p>
                <p style={styles.footerText}>
                    <strong style={styles.footerTextStrong}>주소</strong> : {footerInfo.address}
                </p>
                <p style={styles.footerText}>
                    <strong style={styles.footerTextStrong}>고객센터</strong> : {footerInfo.csPhone}
                    <span style={styles.footerDivider}> | </span>
                    <strong style={styles.footerTextStrong}>이메일</strong> : {footerInfo.email}
                </p>
            </div>
        </footer>
    );
}

export default Footer;